import FormInput from 'components/forms/FormInput';
import { useEffect, useRef } from 'react';
import {
    formatPrimaryPrice,
    formatRateLine,
    getPriceEditDefaultValue,
    getPriceEditPrefix,
    getSaleUsd,
    shouldShowRateLine,
    type DualPriceRow,
} from 'utils/helpers/currency/dualPrice';

export interface DualPriceCellProps {
    row: DualPriceRow;
    rate: number;
    disabled: boolean;
    isEditing: boolean;
    editRatePrice: boolean;
    onOpen: (editRatePrice: boolean) => void;
    onClose: () => void;
    onSave: (value: string | number) => void;
}

const priceLineClass = (disabled: boolean) =>
    `text-muted f-12 mb-0 my-1${disabled ? '' : ' template-price-edit text-break'}`;

const DualPriceCell = ({
    row,
    rate,
    disabled,
    isEditing,
    editRatePrice,
    onOpen,
    onClose,
    onSave,
}: DualPriceCellProps) => {
    const saleUsd = getSaleUsd(row);
    const refInput = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (isEditing && refInput.current) {
            refInput.current.select();
        }
    }, [isEditing]);

    if (isEditing && !disabled) {
        return (
            <FormInput
                autoSelect={true}
                key={String(editRatePrice)}
                compact
                showForm
                setShowForm={(show) => {
                    if (!show) onClose();
                }}
                defaultValue={getPriceEditDefaultValue(row, rate, editRatePrice)}
                decimalPlaces={2}
                prefix={getPriceEditPrefix(rate, editRatePrice)}
                callBack={onSave}
                refInput={refInput}
            />
        );
    }

    return (
        <>
            <p className={priceLineClass(disabled)} onClick={() => !disabled && onOpen(false)}>
                {formatPrimaryPrice(saleUsd, rate)}
            </p>
            {shouldShowRateLine(rate) && (
                <p className={priceLineClass(disabled)} onClick={() => !disabled && onOpen(true)}>
                    {formatRateLine(saleUsd, rate)}
                </p>
            )}
        </>
    );
};

export default DualPriceCell;
